/* eslint-disable react-hooks/exhaustive-deps */
import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm, Tooltip } from 'antd';
import classNames from 'classnames';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DropTarget } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import IconCameraOff from '../../assets/icons/camera_off.svg';
import IconCameraOn from '../../assets/icons/camera_on.svg';
import IconPin from '../../assets/icons/push_pin.svg';
import CardDnd from '../../components/CardDnd';

const sortByName = (a, b) => {
  if (a?.name < b?.name) {
    return -1;
  }

  if (a?.name > b?.name) {
    return 1;
  }

  return 0;
};

const DndPinCameraComponent = ({
  connectDropTarget,
  data,
  select,
  unpinCamera,
  setPinnedCamera,
  setSelectCamera,
  checkGroup,
  setDataArrGroup,
  deleteCameraGroup,
}) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const [cameras, setCameras] = useState(data);

  useEffect(() => {
    if (data) {
      setCameras(data);
    }
  }, [data]);

  const findCard = useCallback(
    (serial) => {
      const camera = cameras.filter((c) => `${c.serial}` === serial)[0];
      return {
        camera,
        index: cameras.indexOf(camera),
      };
    },
    [cameras]
  );
  const moveCard = useCallback(
    (serial, atIndex) => {
      const { camera, index } = findCard(serial);
      if (atIndex !== index) {
        if (checkGroup === 0) {
          setPinnedCamera(
            update(cameras, {
              $splice: [
                [index, 1],
                [atIndex, 0, camera],
              ],
            })
          );
        } else {
          setDataArrGroup(
            update(cameras, {
              $splice: [
                [index, 1],
                [atIndex, 0, camera],
              ],
            })
          );
        }
      }
    },
    [findCard, checkGroup, setPinnedCamera, cameras, setDataArrGroup]
  );

  connectDropTarget(ref);
  return (
    <div ref={ref}>
      {(cameras || []).sort(sortByName).map((camera, index) => (
        <CardDnd
          key={camera.serial}
          id={`${camera.serial}`}
          moveCard={moveCard}
          findCard={findCard}
        >
          <div
            className={classNames('child-pin-camera', {
              selected: select && camera.serial === select,
            })}
            key={camera.serial}
          >
            <div onClick={() => setSelectCamera(camera)} className="info-side">
              <div className="name">
                <div className="cam-icon">
                  <img
                    src={camera.state === 1 ? IconCameraOn : IconCameraOff}
                    alt="camera on"
                    className="camera-icon"
                  />
                </div>
                <Tooltip title={`${camera.name}`}>
                  <div className="cam-name cam-name-text">
                    {` ${camera.name}`}
                  </div>
                </Tooltip>
              </div>
            </div>
            {checkGroup === 0 ? (
              <Popconfirm
                placement="rightTop"
                title={t('Are you sure to unpin this camera?')}
                okText={t('Yes')}
                onConfirm={() => unpinCamera(camera.serial)}
                cancelText={t('No')}
              >
                <div className="unpin-icon">
                  <img src={IconPin} alt="pin" className="camera-icon" />
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                placement="rightTop"
                title={t('Are you sure to delete this camera?')}
                okText={t('Yes')}
                onConfirm={() => deleteCameraGroup(camera)}
                cancelText={t('No')}
              >
                <div className="unpin-icon">
                  <DeleteOutlined className="camera-icon" />
                </div>
              </Popconfirm>
            )}
          </div>
        </CardDnd>
      ))}
    </div>
  );
};
export default DropTarget('card', {}, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(DndPinCameraComponent);
